@if (isLoading()) {
  <div class="flex items-center justify-center py-8">
    <elcia-loader/>
  </div>
} @else if (!hasData()) {
  <div class="flex items-center justify-center py-8 text-sm text-[var(--p-surface-500)]">
    {{ 'dashboard.todos.empty' | translate }}
  </div>
} @else {
  <!-- Row on a narrow card, column once there is room: the doughnut keeps its own size either way. -->
  <div class="flex flex-row items-center gap-4 sm:flex-col sm:items-stretch">

    <!-- The doughnut is hollow so the total sits in its centre: the shape carries the breakdown,
         the figure carries the volume. -->
    <div class="relative h-32 w-32 flex-none self-center">
      <p-chart [data]="data()" [options]="options()" height="128px" type="doughnut"/>
      <div class="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
        <span class="text-2xl leading-none font-bold tabular-nums">{{ pendingCount() }}</span>
        <span class="text-[0.65rem] text-[var(--p-surface-500)]">{{ 'dashboard.todos.pending' | translate }}</span>
      </div>
    </div>

    <div class="flex min-w-0 flex-1 flex-col gap-1.5 sm:flex-none">
      @if (overdueCount() > 0) {
        <!-- Overdue is the one number that demands action today, so it is stated plainly rather than
             left to be read off a slice. -->
        <div class="flex items-baseline gap-1.5">
          <span class="text-2xl leading-none font-bold text-red-600 tabular-nums">{{ overdueCount() }}</span>
          <span class="text-xs font-medium text-red-600">{{ 'dashboard.todos.overdue' | translate }}</span>
        </div>
      }
      @for (slice of data().labels; track slice; let i = $index) {
        <div class="flex min-w-0 items-center gap-1.5 text-xs">
          <span [style.background-color]="data().datasets[0].backgroundColor[i]"
                class="h-2 w-2 flex-none rounded-full"></span>
          <span class="min-w-0 truncate text-[var(--p-surface-600)]">{{ slice }}</span>
          <span class="ml-auto flex-none tabular-nums text-[var(--p-surface-700)]">
            {{ data().datasets[0].data[i] }}
          </span>
        </div>
      }
    </div>
  </div>
}
